export default "__VITE_ASSET__DnUK3Ree__"